import { createSlice } from '@reduxjs/toolkit';
import type { PayloadAction } from '@reduxjs/toolkit';

interface ChangeLanguageNotificationState {
  language: string;
  prevLanguage: string;
}

const initialState: ChangeLanguageNotificationState = {
  language: '',
  prevLanguage: '',
};

export const changeLanguageNotificationSlice = createSlice({
  name: 'changeLanguageNotification',
  initialState,
  reducers: {
    setLanguage: (state, action: PayloadAction<string>) => {
      state.language = action.payload;
    },
    setPrevLanguage: (state, action: PayloadAction<string>) => {
      state.prevLanguage = action.payload;
    },
  },
});

export const { setLanguage, setPrevLanguage } =
  changeLanguageNotificationSlice.actions;

export default changeLanguageNotificationSlice.reducer;
